import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = (app) => ({
  path: '/help',
  title: '帮助中心',
  component: dynamicWrapper(app, [], () => import('./class'))
});

export default (app) => createRoute(app, routesConfig);